@if(buttonType === BUTTON_TYPES.OUTLINED){
  <div 
    matRipple
    [matRippleDisabled]="buttonDisabled"
    [class]="buttonDisabled ? 'button disabled' : 'button outlined'"
    (click)="buttonClicked()">
      {{buttonLabel}}
  </div>
}@else if(buttonType === BUTTON_TYPES.GREEN){
  <div 
    matRipple 
    [matRippleDisabled]="buttonDisabled"
    [class]="buttonDisabled ? 'button disabled' : 'button green'" 
    (click)="buttonClicked()">
      {{buttonLabel}}
  </div>
}@else{
  <div 
    matRipple
    [matRippleDisabled]="buttonDisabled"
    [class]="buttonDisabled ? 'button disabled' : 'button'" 
    (click)="buttonClicked()">
      {{buttonLabel}}
  </div>
}